var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.webSocketStatus.connectionState !== 'connected')?_c('div',{staticClass:"printer-controls"},[_c('printer-calibratrion-modal',{attrs:{"calibrate":_vm.callPrinterCalibrationService,"close":_vm.closeCalibrationModal}}),_vm._v(" "),_c('printer-calibration-button',{attrs:{"open":_vm.openCalibrationModal}})],1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }